import { Field } from 'formik';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import formatCurrency from 'src/util/formatCurrency';

/**
 * Custom Formik Field component for handling currency input
 * @component
 * @param {string} label - The label to be displayed for the input field
 * @param {string} name - The name of the field used in Formik
 * @param {function} onChange - The onChange callback function to be called when the input value changes
 * @param {Object} props - Additional props to be passed to the underlying `Field` component from 'formik'
 */
export default function CurrencyField({ label, name, onChange, ...props }) {
  const handleChange = (e) => {
    onChange(name, formatCurrency(e.target.value));
  };

  return (
    <Field
      InputLabelProps={{ shrink: true }}
      className="flex-1"
      component={MuiValidTextField}
      label={label}
      name={name}
      onChange={(e) => {
        handleChange(e);
      }}
      {...props}
    />
  );
}
